import { styled } from 'styled-components';

export const NoteEditoStyled = styled.div`
  height: auto;
`;
export default NoteEditoStyled;
